// @flow
import * as React from 'react';
import { memoize } from 'lodash';


export type Confirmation = {
    message: string,
    title?: string,
    actions: {
        [string]: {
            label: string,
            callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => void,
            [string]: any,
        }
    },
    actionsAlign?: string,
    position?: string,
    size?: string,
};


type Props = {
    renderer: React.ComponentType<{
        confirmations: Array<Confirmation>,
        onClose: (confirmation: Confirmation) => any,
    }>,
    children: typeof React.Children,
}


type State = {
    confirmations: Array<Confirmation>,
}


export const { Provider, Consumer }: Object = React.createContext({
    confirm: () => {},
});


class ConfirmActions extends React.PureComponent<Props, State> {
    state = {
        confirmations: [],
    };

    constructor(props: Props) {
        super(props);

        this.getContext = memoize(this.getContext);
    }

    getContext = (props: Props) => ({
        confirm: this._confirm,
    });

    _confirm = (confirmation: Confirmation) => {
        this.setState((state) => {
            const confirmations = [...state.confirmations, confirmation];
            return { confirmations };
        });
    };

    handleClose = (confirmation: Confirmation) => {
        this.setState((state) => {
            const index = state.confirmations.indexOf(confirmation);
            const confirmations = [...state.confirmations];
            confirmations.splice(index, 1);
            return { confirmations };
        });
    };

    render() {
        const { renderer: Confirmations, children } = this.props;
        const { confirmations } = this.state;

        return (
            <Provider value={this.getContext(this.props)}>
                {children}
                <Confirmations confirmations={confirmations} onClose={this.handleClose} />
            </Provider>
        );
    }
}

export default ConfirmActions;
